import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Translate } from "react-localize-redux";
import InputField from '../../../components/forms/InputField';
import { renderErrorsList, renderField } from '../../../utils/formUtils';
import {
  recoverAccountAction
} from '../../../redux/actions/accountRecovery.actions';

export class RecoverAccountForm extends React.Component {

  handleRecoverAccount = (values) => {
    this.props.recoverAccountAction(values);
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="col-lg-4 text-center form-margin-container">
        <h3 id="sign-in-brand"><Translate id="RecoverAccount" /></h3>
        <br/>
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 text-center">
            <form onSubmit={handleSubmit(this.handleRecoverAccount)}>
              <Field
                label=""
                hideLabel={true}
                name="user_data"
                type="text"
                id="recover-account-input"
                customClasses="center"
                component={InputField}
                placeholder="Email, phone number or username"
              />
              <br/>
              <button
                type="submit"
                id="send-account-recovery-btn"
                className="btn btn-primary">
                <Translate id="Send" />
              </button>
            </form>
          </div>
        </div>

        <br />
        <ul className="list-group">
          {renderErrorsList(this.props.accountRecovery.errors)}
        </ul>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  if (!values.password) {
    errors.password = "Enter a password"
  }

  if (values.password && values.password.length < 8) {
    errors.password = "Password must be longer than 8 characters"
  }

  if (values.password && !/\d/.test(values.password)) {
    errors.password = "Password must contain at least one number"
  }

  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = "Passwords do not match"
  }

  return errors;
}

const mapStateToProps = ({ accountRecovery }) => ({ accountRecovery });

export default reduxForm({
  validate,
  form: 'RecoverAccountForm'
})(connect(mapStateToProps, { recoverAccountAction })(RecoverAccountForm));



// WEBPACK FOOTER //
// ./src/components/forms/RecoverAccountForm/RecoverAccountForm.jsx